import { useProfileResource } from './useProfileResource';
export interface OwnerCommandCentre {
  dateIst: string; revenueMtd: number; pipeline: { value: number; count: number };
  cashBank: number | null; receivables: number; oee: number | null; shippedToday: number;
  categories: Array<{ label: string; value: number }>;
  departments: { quality: number; qualityOverdue: number; purchase: number; purchaseLate: number; service: number; serviceDue: number; people: number };
  approvals: Array<{ id: string; title: string; detail: string }>;
}
const numeric = (v: unknown) => typeof v === 'number' && Number.isFinite(v);
function parse(body: any): OwnerCommandCentre {
  const d = body?.data;
  if (!d || !/^\d{4}-\d{2}-\d{2}$/.test(d.dateIst)
    || ![d.revenueMtd, d.pipeline?.value, d.pipeline?.count, d.receivables, d.shippedToday,
      ...['quality','qualityOverdue','purchase','purchaseLate','service','serviceDue','people'].map(k => d.departments?.[k])].every(numeric)
    || ![d.cashBank, d.oee].every(v => v === null || numeric(v))
    || !Array.isArray(d.categories) || !d.categories.every((r: any) => typeof r.label === 'string' && numeric(r.value))
    || !Array.isArray(d.approvals) || !d.approvals.every((r: any) => ['id','title','detail'].every(k => typeof r[k] === 'string'))) throw Error('Invalid owner response');
  return d;
}
export const useOwnerCommandCentre = () => useProfileResource('/analytics/owner-dashboard?view=command-centre', parse);
